module.exports = __webpack_public_path__ + "media/images/ww-logo-cf5f50f1.svg";